module.exports = __webpack_public_path__ + "static/media/shell32_147.9ef45a1d.ico";